import type { RouteComponent } from 'vue-router';

export const views: Record<
  PageRoute.LastDegreeRouteKey,
  RouteComponent | (() => Promise<{ default: RouteComponent }>)
> = {
  403: () => import('./_builtin/403/index.vue'),
  404: () => import('./_builtin/404/index.vue'),
  500: () => import('./_builtin/500/index.vue'),
  'constant-page': () => import('./_builtin/constant-page/index.vue'),
  login: () => import('./_builtin/login/index.vue'),
  'not-found': () => import('./_builtin/not-found/index.vue'),
  account_personal: () => import('./account/index.vue'),
  dashboard_report: () => import('./dashboard/report/index.vue'),
  dashboard_business: () => import('./dashboard/business/index.vue'),
  dashboard_mirror: () => import('./dashboard/mirror/index.vue'),
  dashboard_land: () => import('./dashboard/land/index.vue'),
  site_list: () => import('./site/index.vue'),
  bank_list: () => import('./bank/index.vue'),
  accounts_list: () => import('./accounts/index.vue'),
  domains_list: () => import('./domains/index.vue'),
  domains_domain: () => import('./domains/domain/index.vue'),
  server_list: () => import('./server/index.vue'),
  server_terminal: () => import('./server/terminal/index.vue'),
  sys_config: () => import('./system/config/index.vue'),
  sys_permission_menu: () => import('./system/permission/menu/index.vue'),
  sys_permission_role: () => import('./system/permission/role/index.vue'),
  sys_user_list: () => import('./system/user/index.vue'),
  sys_other: () => import('./system/other/index.vue'),
  sys_operator: () => import('./system/monitor/operator/index.vue'),
  monitor: () => import('./site/monitor/index.vue')
};
